const syncSidebarStickyOffset = (section) => {
	const header = document.querySelector(".site-header");

	if (!header) {
		return;
	}

	const update = () => {
		const offset = Math.ceil(header.getBoundingClientRect().height) + 24;
		section.style.setProperty("--resource-article-sticky-top", `${offset}px`);
	};

	update();
	window.addEventListener("resize", update, { passive: true });
	window.addEventListener("scroll", update, { passive: true });
};

const initResourceArticle = (section) => {
	syncSidebarStickyOffset(section);

	const tocLinks = section.querySelectorAll(".resource-article__toc-item a");

	tocLinks.forEach((link) => {
		link.addEventListener("click", (event) => {
			const href = link.getAttribute("href");

			if (!href || !href.startsWith("#")) {
				return;
			}

			const target = document.getElementById(href.slice(1));

			if (!target) {
				return;
			}

			event.preventDefault();
			target.scrollIntoView({ behavior: "smooth", block: "start" });
			history.replaceState(null, "", href);
		});
	});

	const downloadForm = section.querySelector(".resource-article__download-form--fallback");

	if (downloadForm) {
		downloadForm.addEventListener("submit", (event) => {
			event.preventDefault();
		});
	}

	const tocItems = [...section.querySelectorAll(".resource-article__toc-item")];
	const headings = tocItems
		.map((item) => {
			const href = item.querySelector("a")?.getAttribute("href");

			if (!href || !href.startsWith("#")) {
				return null;
			}

			const heading = document.getElementById(href.slice(1));

			return heading ? { item, heading } : null;
		})
		.filter(Boolean);

	if (!headings.length || !("IntersectionObserver" in window)) {
		return;
	}

	const setActive = (activeItem) => {
		tocItems.forEach((item) => {
			item.classList.toggle("is-active", item === activeItem);
		});
	};

	const observer = new IntersectionObserver(
		(entries) => {
			const visible = entries
				.filter((entry) => entry.isIntersecting)
				.sort(
					(a, b) =>
						a.boundingClientRect.top - b.boundingClientRect.top
				);

			if (!visible.length) {
				return;
			}

			const match = headings.find(
				({ heading }) => heading === visible[0].target
			);

			if (match) {
				setActive(match.item);
			}
		},
		{
			root: null,
			rootMargin: "-20% 0px -65% 0px",
			threshold: 0,
		}
	);

	headings.forEach(({ heading }) => observer.observe(heading));
};

const boot = () => {
	document.querySelectorAll(".resource-article").forEach((section) => {
		initResourceArticle(section);
	});
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
